import { createReducer } from '@reduxjs/toolkit';
import {
    DATA_LIST_YEARS, DATA_LIST_MUSICS, CLEAR_LIST_MUSICS, SET_NOT_FOUND,
} from '../actions/Top100Actions';

const initialState = {
    listYears: [],
    listMusics: [],
    currentYear: null,
    notFound: null,
};

const top100 = createReducer(initialState, (builder) => {
    builder
        .addCase(DATA_LIST_YEARS, (state, action) => {
            state.listYears = action.listYears;
        })
        .addCase(DATA_LIST_MUSICS, (state, action) => {
            state.listMusics = action.listMusics;
            state.currentYear = action.year;
        })
        .addCase(CLEAR_LIST_MUSICS, (state) => {
            state.listMusics = [];
        })
        .addCase(SET_NOT_FOUND, (state, action) => {
            state.notFound = action.notFound;
        });
});

export default top100;
